import { customAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const cywareCtix = defineConnector({
  identifier: "cywareCtix",
  name: "Cyware CTIX",
  tagLine: "Threat intelligence exchange",
  logo,
  protocol: "http",
  tags: ["security"],
  defaultUrlPattern: () => "https://[^/]*\\.cyware\\.com/.*",
  auth: customAuth("cywareCtix"),
  steps: [
    {
      title: "Get your Cyware CTIX API details",
      items: [
        {
          kind: "markdown",
          content:
            "To gain Rest API access to CTIX endpoints, you have to generate API credentials for your API user from the CTIX application.\n\n1. Sign in to the CTIX application and from the **Administration** module select **Integrations Management**.\n2. On the left-hand side panel, select **CTIX integrators**.\n3. Click **Add New** to generate API credentials.\n4. Enter a name and a description. Specify a validity period for your API credentials.\n5. Copy the **Access ID**, **Secret Key**, and the **Endpoint URL** displayed to you.",
        },
      ],
    },
    {
      title: "Enter your API credentials",
      items: [
        {
          kind: "input",
          label: "Access ID",
          placeholder: "Paste your Access ID here",
          required: true,
          target: { kind: "secrets", field: "accessId" },
        },
        {
          kind: "input",
          label: "Secret Key",
          placeholder: "Paste your Secret Key here",
          required: true,
          target: { kind: "secrets", field: "secretKey" },
        },
        {
          kind: "hostname",
          label: "Endpoint URL",
          placeholder: "yourdomain.cyware.com",
          helperText: "Your CTIX endpoint URL (e.g., yourdomain.cyware.com)",
          required: true,
          target: { kind: "configuration", field: "endpointUrl" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: ({ endpointUrl }) =>
      `https://${endpointUrl}/ctixapi/v3/system/health/`,
  },
  publicEnvVars: ({ endpointUrl }) => ({
    CYWARE_CTIX_URL: endpointUrl ? `https://${endpointUrl}` : "",
  }),
});
